var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowToFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2740_958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2740_958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45 17.4469L6.05 16.0469L9.075 12.9969H2V10.9969H9.075L6.05 7.94688L7.45 6.54688L12.9 11.9969L7.45 17.4469ZM13 16.9969V14.9969H22V16.9969H13ZM13 8.99688V6.99688H22V8.99688H13ZM16 12.9969V10.9969H22V12.9969H16Z",
    fill: "#054254"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToFileIcon);
export default __webpack_public_path__ + "static/media/arrowToFileIcon.bc25df844d3aa574a525df046c47fb40.svg";
export { ForwardRef as ReactComponent };